var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card card-primary"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"alert alert-info"},[_vm._v("Data ada pada 01/2021")]),_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Calendar")])])
}]

export { render, staticRenderFns }